import { StatusTransportadora } from './enum';

export class Transportadora {
  id: string;
  nome: string;
  fantasia: string;
  cnpj: string;
  cep: string;
  ibge: string;
  rua: string;
  n: string;
  compl: string;
  bairro: string;
  cidade: string;
  email: string;
  uf: string;
  tel1: string;
  ativo: StatusTransportadora;
  site: string;
  contato: string;
  codErp: string;
}
